import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import { FiChevronDown } from "react-icons/fi";

import { useUser } from "../../context/UserContext";
import logo from "../../assets/img/logoblanco.png";
import userImg from "../../assets/img/team-1.jpg";

interface UserNavProps {
  nombreUsuario?: string;
  nombreInmobiliaria?: string;
}

export default function UserNav({
  nombreUsuario,
}: UserNavProps) {
  const [activeMenu, setActiveMenu] = useState<{
    [key: string]: { [key: string]: boolean };
  }>({});
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [toggle, setIsToggle] = useState<boolean>(false);
  const [userMenu, setUserMenu] = useState<boolean>(false);
  const { user, logout } = useUser();

  const fullName = user?.nombre || nombreUsuario || "Usuario";
  const displayName = fullName.split(" ")[0];

  let [scroll, setScroll] = useState<boolean>(false);

  const location = useLocation();
  const current = location.pathname;

  const handleMouseEnter = (menu: string, submenu?: string) => {
    setActiveMenu((prev) => ({
      ...prev,
      [menu]: {
        ...prev[menu],
        [submenu || "main"]: true,
      },
    }));
  };

  const handleMouseLeave = (menu: string, submenu?: string) => {
    setActiveMenu((prev) => ({
      ...prev,
      [menu]: {
        ...prev[menu],
        [submenu || "main"]: false,
      },
    }));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const handlerScroll = () => {
      if (window.scrollY > 50) {
        setScroll(true);
      } else {
        setScroll(false);
      }
    };
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("scroll", handlerScroll);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("scroll", handlerScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isAdmin = () => user?.rol === "ADMIN";
  const isAsociado = () => user?.rol === "ASOCIADO";
  const isAfiliado = () => user?.rol === "AFILIADO";


  return (
    <>
      {/* ========== CONVENTIONAL NAVBAR ========== */}
      <div
        className={`header header-light head-shadow ${
          scroll ? "header-fixed" : ""
        }`}
      >
        <div className="container">
          <nav
            id="navigation"
            className={
              windowWidth > 991
                ? "navigation navigation-landscape"
                : "navigation navigation-portrait"
            }
          >
            <div className="nav-header" style={{ lineHeight: "0" }}>
              <Link className="nav-brand text-logo" to="/">
                <img src={logo} alt="Logo AMPI Riviera Nayarit" />
              </Link>

              <button
                className="nav-toggle"
                onClick={() => setIsToggle(!toggle)}
                aria-label="Abrir menú de navegación"
                aria-expanded={toggle}
              ></button>

              <div className="mobile_nav">
                <ul>
                  {user && ["ADMIN", "ASOCIADO"].includes(user.rol) && (
                    <li>
                      <Link to="/submit-property" className="text-primary">
                        <span className="svg-icon svg-icon-2hx">
                          <svg width="35" height="35" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor" />
                            <rect x="10.8891" y="17.8033" width="12" height="2" rx="1" transform="rotate(-90 10.8891 17.8033)" fill="currentColor" />
                            <rect x="6.01041" y="10.9247" width="12" height="2" rx="1" fill="currentColor" />
                          </svg>
                        </span>
                      </Link>
                    </li>
                  )}
                  <li>
                    <div className="btn-group account-drop">
                      <button
                        type="button"
                        className="btn btn-order-by-filt dropdown-toggle"
                        id="showbuttons"
                        onClick={() => setUserMenu(!userMenu)}
                      >
                        <img src={userImg} className="avater-img" alt="Foto de perfil del usuario" />
                      </button>
                      <div
                        className="dropdown-menu pull-right animated flipInX"
                        id="showings"
                        style={{ display: userMenu ? "block" : "none" }}
                      >
                        <Link to="/dashboard"><i className="fa-solid fa-gauge"></i> Dashboard</Link>
                        <Link to="/my-profile"><i className="fa-solid fa-address-card"></i> Mi Perfil</Link>
                        {(isAsociado() || isAfiliado()) && (
                          <Link to="/my-property"><i className="fa-solid fa-building-circle-check"></i> Mis Propiedades</Link>
                        )}
                        {(isAdmin() || isAsociado()) && (
                          <Link to="/submit-property-dashboard"><i className="fa-solid fa-house"></i> Publicar Propiedad</Link>
                        )}
                        <Link to="/change-password"><i className="fa-solid fa-unlock"></i> Cambiar Contraseña</Link>
                        <Link to="/calificacion"><i className="fa-solid fa-star"></i> Asignar Calificación</Link>
                        <button
                          onClick={logout}
                          className="dropdown-item logout-btn-red"
                          style={{ background: "none", border: "none", width: "100%", textAlign: "left", padding: "0.5rem 1rem" }}
                        >
                          <i className="fa-solid fa-right-from-bracket"></i> <span>Cerrar Sesión</span>
                        </button>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div
              className={`nav-menus-wrapper ${toggle ? "nav-menus-wrapper-open" : ""}`}
              style={{ transitionProperty: toggle ? "none" : "left" }}
            >
              <button
                className="nav-menus-wrapper-close-button"
                onClick={() => setIsToggle(!toggle)}
                aria-label="Cerrar menú de navegación"
              >
                ✕
              </button>
              <ul className="nav-menu" style={{ float: "right" }}>
                <li className={current === "/" ? "active" : ""}>
                  <Link to="/">Inicio</Link>
                </li>
                <li className={["/classical-layout-with-sidebar"].includes(current) ? "active" : ""}>
                  <Link to="/classical-layout-with-sidebar">Propiedades</Link>
                </li>
                <li
                  className={`${["/agents", "/agent-page", "/asociados", "/asociado-page"].includes(current) ? "active" : ""} ${activeMenu["members"]?.main ? "show" : ""}`}
                  onMouseEnter={() => handleMouseEnter("members")}
                  onMouseLeave={() => handleMouseLeave("members")}
                >
                  <Link to="#">Miembros AMPI<FiChevronDown className="submenu-indicator" /></Link>
                  <ul className="nav-dropdown nav-submenu" style={{ display: activeMenu["members"]?.main ? "block" : "none", pointerEvents: activeMenu["members"]?.main ? "auto" : "none" }}>
                    <li><Link to="/agents" className={current === "/agents" ? "active" : ""}>Afiliados</Link></li>
                    <li><Link to="/asociados" className={current === "/asociados" ? "active" : ""}>Asociados</Link></li>
                  </ul>
                </li>
                <li className={["/agencies", "/agency-page"].includes(current) ? "active" : ""}>
                  <Link to="/agencies">Agencias</Link>
                </li>
                {isAdmin() && (
                  <li
                    className={`${["/escanear-asistencia", "/create-taller", "/aprobar-propiedades", "/admin-dashboard"].includes(current) ? "active" : ""} ${activeMenu["admin"]?.main ? "show" : ""}`}
                    onMouseEnter={() => handleMouseEnter("admin")}
                    onMouseLeave={() => handleMouseLeave("admin")}
                  >
                    <Link to="#">Administrador<FiChevronDown className="submenu-indicator" /></Link>
                    <ul className="nav-dropdown nav-submenu" style={{ display: activeMenu["admin"]?.main ? "block" : "none", pointerEvents: activeMenu["admin"]?.main ? "auto" : "none" }}>
                      <li><Link to="/admin-dashboard" className={current === "/admin-dashboard" ? "active" : ""}>Panel Administrativo</Link></li>
                      <li><Link to="/ver-taller" className={current === "/ver-taller" ? "active" : ""}>Ver Cursos</Link></li>
                      <li><Link to="/admin-talleres" className={current === "/admin-talleres" ? "active" : ""}>Administrar Cursos</Link></li>
                      <li><Link to="/escanear-asistencia" className={current === "/escanear-asistencia" ? "active" : ""}>Escanear Asistencia</Link></li>
                      <li><Link to="/aprobar-propiedades" className={current === "/aprobar-propiedades" ? "active" : ""}>Aprobar Propiedades</Link></li>
                      <li><Link to="/aprobar-resena" className={current === "/aprobar-resena" ? "active" : ""}>Aprobar Reseñas</Link></li>
                      <li><Link to="/admin-inm" className={current === "/admin-inm" ? "active" : ""}>Gestionar Agencias</Link></li>
                      <li><Link to="/admin-property" className={current === "/admin-property" ? "active" : ""}>Gestionar Propiedades</Link></li>
                      <li><Link to="/admin-project" className={current === "/admin-project" ? "active" : ""}>Gestionar Proyectos</Link></li>
                      <li><Link to="/admin-afiliado" className={current === "/admin-afiliado" ? "active" : ""}>Gestionar Afiliados</Link></li>
                      <li><Link to="/admin-asociado" className={current === "/admin-asociado" ? "active" : ""}>Gestionar Asociados</Link></li>
                    </ul>
                  </li>
                )}

                {/* User dropdown - al final del menú */}
                <li className="d-none d-lg-inline-block" style={{ marginLeft: 20, borderLeft: "1px solid rgba(255,255,255,0.2)", paddingLeft: 15 }}>
                  <div className="btn-group account-drop">
                    <button
                      type="button"
                      className="btn btn-order-by-filt dropdown-toggle"
                      onClick={() => setUserMenu(!userMenu)}
                    >
                      <i className="fa-solid fa-user avater-img"></i>
                      <span className="ms-2">Hola, {displayName}</span>
                    </button>
                    <div
                      className="dropdown-menu pull-right animated flipInX"
                      style={{ display: userMenu ? "block" : "none" }}
                    >
                      <Link to="/dashboard"><i className="fa-solid fa-gauge"></i> Dashboard</Link>
                      <Link to="/my-profile"><i className="fa-solid fa-address-card"></i> Mi Perfil</Link>
                      {(isAsociado() || isAfiliado()) && (
                        <Link to="/my-property"><i className="fa-solid fa-building-circle-check"></i> Mis Propiedades</Link>
                      )}
                      {(isAdmin() || isAsociado()) && (
                        <Link to="/submit-property-dashboard"><i className="fa-solid fa-house"></i> Publicar Propiedad</Link>
                      )}
                      <Link to="/change-password"><i className="fa-solid fa-unlock"></i> Cambiar Contraseña</Link>
                      {!isAdmin() && (
                        <Link to="/ver-taller"><i className="fa-solid fa-graduation-cap"></i> Ver Cursos</Link>
                      )}
                      <Link to="/calificacion"><i className="fa-solid fa-star"></i> Asignar Calificación</Link>
                      <button
                        onClick={logout}
                        className="dropdown-item logout-btn-red"
                        style={{ background: "none", border: "none", width: "100%", textAlign: "left", padding: "0.5rem 1rem" }}
                      >
                        <i className="fa-solid fa-right-from-bracket"></i> <span>Cerrar Sesión</span>
                      </button>
                    </div>
                  </div>
                </li>
              </ul>

            </div>
            <div
              className="nav-overlay-panel"
              style={{ backgroundColor: "rgba(0, 0, 0, 0.5)", display: toggle ? "block" : "none" }}
            ></div>
          </nav>
        </div>
      </div>
      <div className="clearfix"></div>

      {/* ========== FLOATING BUTTON - SITIO OFICIAL ========== */}
      <a
        href="https://ampirivieranayarit.com/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Visitar sitio oficial AMPI"
        style={{
          position: "fixed", bottom: 70, right: 24, zIndex: 1050,
          width: 52, height: 52, borderRadius: "50%",
          display: "flex", alignItems: "center", justifyContent: "center",
          backgroundColor: "#1a5d4a",
          boxShadow: "0 4px 16px rgba(26,93,74,0.4)",
          color: "#fff", fontSize: 22, textDecoration: "none",
          transition: "transform 0.2s, box-shadow 0.2s",
        }}
        onMouseEnter={e => { e.currentTarget.style.transform = "scale(1.1)"; }}
        onMouseLeave={e => { e.currentTarget.style.transform = "scale(1)"; }}
      >
        <i className="fa fa-globe" aria-hidden="true"></i>
      </a>
    </>
  );
}
